// Guess-detection of soft keyboard being closed.

const callbacks = new Set();

let windowInnerW = window.innerWidth;
let windowInnerH = window.innerHeight;

window.addEventListener('resize', (e) => {
  const deltaW = window.innerWidth - windowInnerW;
  const deltaH = window.innerHeight - windowInnerH;
  windowInnerW = window.innerWidth;
  windowInnerH = window.innerHeight;
  if (deltaW === 0 && deltaH > 0) {
    // Likely keyboard closed, at least if there was focus on some element.
    for (const callback of callbacks) {
      callback(e);
    }
  }
});

export function addCallbackForMaybeKeybordFold(callback) {
  if (typeof callback === 'function') {
    callbacks.add(callback);
  }
}

export function removeCallbackForMaybeKeybordFold(callback) {
  callbacks.delete(callback);
}
